import { Accordion } from "react-bootstrap";
import {EInvoiceTransactionList} from "./eInvoiceTransactionsList";

export const EInvoiceTransaction = () => {
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header></Accordion.Header>
          <Accordion.Body>
            <EInvoiceTransactionList />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
